// extracted by mini-css-extract-plugin
export default {"contact-section":"ContactUs_contact-section__adfZE","contact-email":"ContactUs_contact-email__H7VX+"};